const url = '/service-types';
const Provider = 'ServiceTypes';
const dbModel = 'ServiceTypes';

export { url, Provider, dbModel };
